import {connect} from '../../app/connect';
import ResponseInlineEdit from './ResponseInlineEdit';
import {getEntityUserNameGetter} from '../../app/selectors';

const mapStateToProps = state => ({
  getEntityDisplayNameById: getEntityUserNameGetter(state)
});

export default connect(
  mapStateToProps,
  {}
)(ResponseInlineEdit);
